import Box from '@mui/material/Box';
import { FieldArray, useFormikContext } from 'formik';
import { Dispatch, memo, SetStateAction, useState } from 'react';

import { ResourceType } from '../../../backend';
import { LeftMenu } from '../../navigation/LeftNavigation/LeftMenu';
import { ResourcesPageFormValues } from '../../pages/ResourcesPage';
import { PropertiesMenu } from './ResourceFields/Properties/PropertiesMenu';
import { ResourceFieldsLineContainer } from './ResourceFields/ResourceFieldsLine/ResourceFieldsLineContainer';

export const ResourceFieldsContainer = memo(function ResourceFieldsContainer({
    search,
    resourceType,
    setResourceType,
}: {
    search: string;
    resourceType: ResourceType;
    setResourceType: Dispatch<SetStateAction<ResourceType>>;
}) {
    const [selectedResources, setSelectedResources] = useState<number[]>([]);

    const { values, dirty } = useFormikContext<ResourcesPageFormValues>();

    return (
        <FieldArray
            name="resources"
            render={({ replace, push, remove }) => (
                <Box display={'flex'} flexDirection={'row'} width={'100%'} height={'100%'} overflow={'hidden'}>
                    <LeftMenu valueType={resourceType} setValueType={setResourceType} arrayPush={push} dirty={dirty} />

                    {values && (
                        <Box
                            key={resourceType}
                            display={'flex'}
                            flexDirection={'column'}
                            width={'85%'}
                            height={'100%'}
                            overflow={'hidden'}
                        >
                            <PropertiesMenu
                                resourceType={resourceType}
                                selectedResources={selectedResources}
                                setSelectedResources={setSelectedResources}
                                arrayRemove={remove}
                            />
                            <ResourceFieldsLineContainer
                                arrayRemove={remove}
                                arrayReplace={replace}
                                resourceType={resourceType}
                                selectedResources={selectedResources}
                                setSelectedResources={setSelectedResources}
                                search={search}
                            />
                        </Box>
                    )}
                </Box>
            )}
        />
    );
});
